import React from 'react'

import {
    Card, CardHeader, CardMedia, CardContent, withStyles
} from 'material-ui'
import classNames from 'classnames'

const styles = theme => ({
    media: {
        height: 400
    }
})


export const CaptionImage = withStyles(styles)(
    ({classes, className='', src, title, alt}) => (
        <Card className={classNames(classes.root, className)}>
            <CardHeader title={alt}/>
            <CardMedia className={classes.media} image={src} title={alt}/>
            <CardContent>
                <p>{title}</p>
            </CardContent>
        </Card>
    )
)

export default CaptionImage


// WEBPACK FOOTER //
// ./src/components/CaptionImage.jsx